import { Filter, X } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { cn } from "@/lib/utils";
import { descriereFiltru, type FiltruRaport } from "@/utils/targetareRaport";
import type { ColoanaTabel, RandRaport } from "@/utils/targetareTabel";

type ChipuriFiltreProps<R extends RandRaport> = {
  coloane: ColoanaTabel<R>[];
  filtre: FiltruRaport[];
  onComuta: (id: string, activ: boolean) => void;
  onEditeaza: (filtru: FiltruRaport) => void;
  onSterge: (id: string) => void;
};

export function ChipuriFiltre<R extends RandRaport>({
  coloane,
  filtre,
  onComuta,
  onEditeaza,
  onSterge,
}: ChipuriFiltreProps<R>) {
  if (filtre.length === 0) return null;
  return (
    <ul
      className="flex flex-wrap gap-2 border-x border-b bg-muted/30 px-3 py-2"
      aria-label="Filtre active"
    >
      {filtre.map((f) => (
        <li
          key={f.id}
          className={cn(
            "flex items-center gap-2 rounded border bg-background px-2 py-1 text-sm",
            !f.activ && "opacity-60"
          )}
        >
          <Checkbox
            checked={f.activ}
            onCheckedChange={(v) => onComuta(f.id, v === true)}
            aria-label={`Activează filtrul ${descriereFiltru(coloane, f)}`}
          />
          <span className="flex h-5 w-5 items-center justify-center rounded bg-ds-green-500 text-black">
            <Filter className="h-3 w-3" />
          </span>
          <button
            type="button"
            className="text-ds-blue-700 hover:underline"
            onClick={() => onEditeaza(f)}
          >
            {descriereFiltru(coloane, f)}
          </button>
          <button
            type="button"
            className="ml-1 text-muted-foreground hover:text-foreground"
            onClick={() => onSterge(f.id)}
            aria-label="Șterge filtrul"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </li>
      ))}
    </ul>
  );
}
